import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/ibm-plex-sans-thai/400.css';
import '@fontsource/ibm-plex-sans-thai/500.css';
import '@fontsource/ibm-plex-sans-thai/600.css';
import '@fontsource/ibm-plex-sans-thai/700.css';
import './i18n';

import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';


// import './assets/css/snippets.min.css';
import './assets/css/theme.min.css';
// import './assets/css/docs.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "react-loading-skeleton/dist/skeleton.css";
import './index.css';
import App from './App';

// Auto-recovery when a new version is deployed and old code chunks are missing
const isChunkError = (error) => {
  if (!error) return false;
  const msg = typeof error === 'string' ? error : (error.message || error.name || '');
  return (
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading CSS chunk')
  );
};

const handleChunkError = (error) => {
  if (isChunkError(error)) {
    const reloadKey = 'crm_chunk_reload_lock';
    const lastReload = sessionStorage.getItem(reloadKey);
    const now = Date.now();
    // Allow reload at most once every 10 seconds to prevent infinite reload loops
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem(reloadKey, now.toString());
      console.warn('[kitCRM] New version detected or chunk load failed. Auto-refreshing to load latest version...');
      window.location.reload();
    }
  }
};

window.addEventListener('error', (event) => {
  handleChunkError(event.error || event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  handleChunkError(event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

